export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AuthenticationInput = {
  data?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ConfigSchemas = {
  __typename?: 'ConfigSchemas';
  flowComponentsSchema: Scalars['JSON'];
  mappingSchema: Scalars['JSON'];
  modelSchema: Scalars['JSON'];
};

export enum ContentStatus {
  Deployed = 'Deployed',
  Draft = 'Draft',
  Eol = 'EOL',
  New = 'New',
  Published = 'Published'
}

export type CreateEntityInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  packageVersionUuid: Scalars['String'];
  schema: Scalars['JSON'];
  uuid: Scalars['ID'];
};

export type CreateMockDataInput = {
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endpointUuid?: InputMaybe<Scalars['String']>;
  mappingUuid?: InputMaybe<Scalars['String']>;
  modelUuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
  source: Scalars['JSON'];
  uuid: Scalars['ID'];
};

export type CreatePackageInput = {
  companyUuid: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};

export type CreatePackageVersionFromPreviousInput = {
  createdBy: Scalars['String'];
  newPackageVersionUuid: Scalars['String'];
  version: Scalars['String'];
};

export type CreatePackageVersionInput = {
  createdBy: Scalars['String'];
  packageUuid: Scalars['String'];
  uuid: Scalars['String'];
  variables: Scalars['JSON'];
  version: Scalars['String'];
};

export type DateTimeRange = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export type DetectDataSchemaInput = {
  data: Scalars['String'];
  env?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

export type EntityType = {
  __typename?: 'EntityType';
  accountUuid: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['String'];
  modifiedBy: Scalars['String'];
  name: Scalars['String'];
  packageVersionUuid: Scalars['String'];
  schema: Scalars['JSON'];
  status: ContentStatus;
  uuid: Scalars['String'];
};

export type EntityTypeWithMetadata = {
  __typename?: 'EntityTypeWithMetadata';
  currentItems: Scalars['Float'];
  data: Array<EntityType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type EnvironmentType = {
  __typename?: 'EnvironmentType';
  accountUuid: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  gatewayUrl?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['String'];
  modifiedBy: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type Environments = {
  __typename?: 'Environments';
  currentItems: Scalars['Float'];
  data: Array<EnvironmentType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type ExecuteManagementCommandInput = {
  uuid: Scalars['String'];
};

export type ExecuteManagementCommandLogLine = {
  __typename?: 'ExecuteManagementCommandLogLine';
  action?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  instanceType?: Maybe<Scalars['String']>;
  message: Scalars['JSON'];
  uuid: Scalars['String'];
};

export type ExecuteManagementCommandResult = {
  __typename?: 'ExecuteManagementCommandResult';
  exchangeName: Scalars['String'];
  queueName: Scalars['String'];
  uuid: Scalars['String'];
};

export type ExecuteRequestInput = {
  authentication?: InputMaybe<AuthenticationInput>;
  body?: InputMaybe<Scalars['String']>;
  headers?: InputMaybe<Array<Array<Scalars['String']>>>;
  method: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type ExecuteRequestLogLine = {
  __typename?: 'ExecuteRequestLogLine';
  date: Scalars['String'];
  log: Scalars['String'];
  uuid: Scalars['String'];
};

export type ExecuteRequestResult = {
  __typename?: 'ExecuteRequestResult';
  headers: Array<Array<Scalars['String']>>;
  resultBody?: Maybe<Scalars['String']>;
  resultCode: Scalars['String'];
};

export type FlowEntityType = {
  __typename?: 'FlowEntityType';
  accountUuid: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flowType: Scalars['String'];
  modifiedAt: Scalars['String'];
  modifiedBy: Scalars['String'];
  name: Scalars['String'];
  packageVersionUuid: Scalars['String'];
  schema: Scalars['JSON'];
  status: ContentStatus;
  uuid: Scalars['String'];
  validation: Scalars['JSON'];
};

export type FlowEntityTypeWithMetadata = {
  __typename?: 'FlowEntityTypeWithMetadata';
  currentItems: Scalars['Float'];
  data: Array<FlowEntityType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type GcpLogType = {
  __typename?: 'GCPLogType';
  level_name?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  timestamp: Scalars['String'];
};

export type GetFlowByPackageVersionInput = {
  flowType?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
};

export type GetInputParams = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
};

export type GetMockDataInput = {
  endpointUuid?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  mappingUuid?: InputMaybe<Scalars['String']>;
  modelUuid?: InputMaybe<Scalars['String']>;
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
};

export type GetPackageVersionEntitiesInput = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
};

export type GetPackageVersionsInput = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  packageUuid: Scalars['String'];
};

export type GetRuntimeLogsByFlowInput = {
  flowUuid?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  packageVersionUuid?: InputMaybe<Scalars['String']>;
};

export type GetRuntimeLogsInput = {
  flowUuid?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LogAppName = {
  name: Scalars['String'];
};

export type LogListFilters = {
  app?: InputMaybe<Array<LogAppName>>;
  dateRange: DateTimeRange;
  keyword?: InputMaybe<Scalars['String']>;
  module: SafeString;
  phrase: SafeString;
  severity?: InputMaybe<Array<LogSeverity>>;
};

export type LogListInput = {
  accountUuid: Scalars['String'];
  filters?: InputMaybe<LogListFilters>;
  packageVersionUuid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
};

export enum LogSeverity {
  Critical = 'CRITICAL',
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Trace = 'TRACE',
  Warning = 'WARNING'
}

export type ManagementCommandLogLineAddedInput = {
  exchangeName: Scalars['String'];
  queueName: Scalars['String'];
  uuid: Scalars['String'];
};

export type MockDataType = {
  __typename?: 'MockDataType';
  accountUuid: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  data?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  endpointUuid?: Maybe<Scalars['String']>;
  mappingUuid?: Maybe<Scalars['String']>;
  modelUuid?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['String'];
  modifiedBy: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
  source: Scalars['JSON'];
  uuid: Scalars['ID'];
};

export type MockDataTypeWithMetadata = {
  __typename?: 'MockDataTypeWithMetadata';
  currentItems: Scalars['Float'];
  data: Array<MockDataType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createEndpoint: Scalars['String'];
  createFlow: Scalars['String'];
  createMapping: Scalars['String'];
  createMockData: Scalars['String'];
  createModel: Scalars['String'];
  createPackage: Scalars['String'];
  createPackageVersion: Scalars['String'];
  createPackageVersionFromPrevious: Scalars['String'];
  deleteEndpoint: Scalars['Boolean'];
  deleteFlow: Scalars['Boolean'];
  deleteMapping: Scalars['Boolean'];
  deleteMockData: Scalars['Boolean'];
  deleteModel: Scalars['Boolean'];
  deletePackage: Scalars['Boolean'];
  deletePackageVersion: Scalars['Boolean'];
  deployPackageVersion: Scalars['Boolean'];
  detectDataSchema: Scalars['JSON'];
  executeRequest: ExecuteRequestResult;
  executeStatusCommand: ExecuteManagementCommandResult;
  parseData: Scalars['JSON'];
  post: Scalars['String'];
  runMapping: RunMappingResult;
  undeployPackageVersion: Scalars['Boolean'];
  updateEndpoint: Scalars['String'];
  updateEndpointName: Scalars['String'];
  updateEndpointSchema: Scalars['String'];
  updateFlow: Scalars['String'];
  updateFlowName: Scalars['String'];
  updateFlowSchema: Scalars['String'];
  updateMapping: Scalars['String'];
  updateMappingName: Scalars['String'];
  updateMappingSchema: Scalars['String'];
  updateMockData: MockDataType;
  updateModel: Scalars['String'];
  updateModelName: Scalars['String'];
  updateModelSchema: Scalars['String'];
  updatePackage: Scalars['String'];
  updatePackageVersionStatus: Scalars['String'];
  updatePackageVersionVariables: Scalars['String'];
  validateStructureSchema: SchemaValidationType;
  validateToSchema: ValidateToSchemaResult;
};


export type MutationCreateEndpointArgs = {
  args: CreateEntityInput;
};


export type MutationCreateFlowArgs = {
  args: CreateEntityInput;
};


export type MutationCreateMappingArgs = {
  args: CreateEntityInput;
};


export type MutationCreateMockDataArgs = {
  args: CreateMockDataInput;
};


export type MutationCreateModelArgs = {
  args: CreateEntityInput;
};


export type MutationCreatePackageArgs = {
  args: CreatePackageInput;
};


export type MutationCreatePackageVersionArgs = {
  args: CreatePackageVersionInput;
};


export type MutationCreatePackageVersionFromPreviousArgs = {
  args: CreatePackageVersionFromPreviousInput;
  uuid: Scalars['String'];
};


export type MutationDeleteEndpointArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationDeleteFlowArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationDeleteMappingArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationDeleteMockDataArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationDeleteModelArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationDeletePackageArgs = {
  uuid: Scalars['String'];
};


export type MutationDeletePackageVersionArgs = {
  uuid: Scalars['String'];
};


export type MutationDeployPackageVersionArgs = {
  uuid: Scalars['String'];
};


export type MutationDetectDataSchemaArgs = {
  args: DetectDataSchemaInput;
};


export type MutationExecuteRequestArgs = {
  args: ExecuteRequestInput;
};


export type MutationExecuteStatusCommandArgs = {
  args: ExecuteManagementCommandInput;
};


export type MutationParseDataArgs = {
  args: ParseSchemaInput;
};


export type MutationRunMappingArgs = {
  args: RunMappingInput;
};


export type MutationUndeployPackageVersionArgs = {
  uuid: Scalars['String'];
};


export type MutationUpdateEndpointArgs = {
  args: UpdateEntityNameDescriptionInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateEndpointNameArgs = {
  args: UpdateEntityNameInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateEndpointSchemaArgs = {
  args: UpdateEntitySchemaInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateFlowArgs = {
  args: UpdateEntityNameDescriptionInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateFlowNameArgs = {
  args: UpdateEntityNameInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateFlowSchemaArgs = {
  args: UpdateEntitySchemaInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateMappingArgs = {
  args: UpdateEntityNameDescriptionInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateMappingNameArgs = {
  args: UpdateEntityNameInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateMappingSchemaArgs = {
  args: UpdateEntitySchemaInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateMockDataArgs = {
  args: UpdateMockDataInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateModelArgs = {
  args: UpdateEntityNameDescriptionInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateModelNameArgs = {
  args: UpdateEntityNameInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdateModelSchemaArgs = {
  args: UpdateEntitySchemaInput;
  packageVersionUuid: Scalars['String'];
};


export type MutationUpdatePackageArgs = {
  args: UpdatePackageInput;
};


export type MutationUpdatePackageVersionStatusArgs = {
  args: UpdatePackageVersionStatusInput;
};


export type MutationUpdatePackageVersionVariablesArgs = {
  args: UpdatePackageVersionVariablesInput;
};


export type MutationValidateStructureSchemaArgs = {
  args: ValidateEntitySchemaInput;
};


export type MutationValidateToSchemaArgs = {
  args: ValidateToSchemaInput;
};

export type PackageContentInfo = {
  __typename?: 'PackageContentInfo';
  availableVersions: Scalars['String'];
  latestVersion: Scalars['String'];
  publishedVersions: Scalars['String'];
};

export type PackageType = {
  __typename?: 'PackageType';
  accountUuid: Scalars['String'];
  companyUuid: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  modifiedAt: Scalars['String'];
  modifiedBy: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type PackageVersionContentInfo = {
  __typename?: 'PackageVersionContentInfo';
  endpoints: Scalars['String'];
  flows: Scalars['String'];
  mappings: Scalars['String'];
  models: Scalars['String'];
};

export type PackageVersionEntityUsageInfo = {
  __typename?: 'PackageVersionEntityUsageInfo';
  endpoints: Array<PackageVersionEntityUsageInfoItem>;
  flows: Array<PackageVersionEntityUsageInfoItem>;
  mappings: Array<PackageVersionEntityUsageInfoItem>;
  models: Array<PackageVersionEntityUsageInfoItem>;
};

export type PackageVersionEntityUsageInfoItem = {
  __typename?: 'PackageVersionEntityUsageInfoItem';
  description: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type PackageVersionType = {
  __typename?: 'PackageVersionType';
  accountUuid: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  deleted: Scalars['Boolean'];
  deployedAt?: Maybe<Scalars['String']>;
  deployedBy?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['String'];
  modifiedBy: Scalars['String'];
  packageUuid: Scalars['String'];
  status: ContentStatus;
  uuid: Scalars['String'];
  variables: Scalars['JSON'];
  version: Scalars['String'];
};

export type PackageVersionsWithMetadata = {
  __typename?: 'PackageVersionsWithMetadata';
  currentItems: Scalars['Float'];
  data: Array<PackageVersionType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type PackagesWithMetadata = {
  __typename?: 'PackagesWithMetadata';
  currentItems: Scalars['Float'];
  data: Array<PackageType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type PaginationInput = {
  page: Scalars['Float'];
  size: Scalars['Float'];
};

export type ParseSchemaInput = {
  data: Scalars['String'];
  env?: InputMaybe<Scalars['String']>;
  schema: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  app: Scalars['String'];
  getAllPackageVersions: PackageVersionsWithMetadata;
  getAllPackages: PackagesWithMetadata;
  getConfigSchemas: ConfigSchemas;
  getEndpoint: EntityType;
  getEndpointsByPackageVersion: EntityTypeWithMetadata;
  getEntityUsageInfo: PackageVersionEntityUsageInfo;
  getEnvironment: EnvironmentType;
  getEnvironmentByAccount: Environments;
  getFlow: FlowEntityType;
  getFlowsByPackageVersion: FlowEntityTypeWithMetadata;
  getLogs: Array<GcpLogType>;
  getMapping: EntityType;
  getMappingsByPackageVersion: EntityTypeWithMetadata;
  getMockData: MockDataType;
  getMockDataByPackageVersion: MockDataTypeWithMetadata;
  getModel: EntityType;
  getModelsByPackageVersion: EntityTypeWithMetadata;
  getPackage: PackageType;
  getPackageContentInfo: PackageContentInfo;
  getPackageVersion: PackageVersionType;
  getPackageVersionContentInfo: PackageVersionContentInfo;
  getRuntimeLogs: RuntimeLogs;
  getRuntimeLogsByFlow: RuntimeLogsForFlow;
};


export type QueryGetAllPackageVersionsArgs = {
  args: GetPackageVersionsInput;
};


export type QueryGetAllPackagesArgs = {
  args: GetInputParams;
};


export type QueryGetEndpointArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetEndpointsByPackageVersionArgs = {
  args: GetPackageVersionEntitiesInput;
};


export type QueryGetEntityUsageInfoArgs = {
  entityKey: Scalars['String'];
  entityType: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type QueryGetEnvironmentArgs = {
  uuid: Scalars['String'];
};


export type QueryGetEnvironmentByAccountArgs = {
  args: GetInputParams;
};


export type QueryGetFlowArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetFlowsByPackageVersionArgs = {
  args: GetFlowByPackageVersionInput;
};


export type QueryGetLogsArgs = {
  input: LogListInput;
};


export type QueryGetMappingArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetMappingsByPackageVersionArgs = {
  args: GetPackageVersionEntitiesInput;
};


export type QueryGetMockDataArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetMockDataByPackageVersionArgs = {
  args: GetMockDataInput;
};


export type QueryGetModelArgs = {
  packageVersionUuid: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetModelsByPackageVersionArgs = {
  args: GetPackageVersionEntitiesInput;
};


export type QueryGetPackageArgs = {
  uuid: Scalars['String'];
};


export type QueryGetPackageContentInfoArgs = {
  packageUuid: Scalars['String'];
};


export type QueryGetPackageVersionArgs = {
  uuid: Scalars['String'];
};


export type QueryGetPackageVersionContentInfoArgs = {
  versionUuid: Scalars['String'];
};


export type QueryGetRuntimeLogsArgs = {
  args: GetRuntimeLogsInput;
};


export type QueryGetRuntimeLogsByFlowArgs = {
  args: GetRuntimeLogsByFlowInput;
};

export type RequestLogLineAddedInput = {
  uuid: Scalars['String'];
};

export type RunMappingInput = {
  config_variables?: InputMaybe<Scalars['JSON']>;
  data: Scalars['String'];
  mapping: Scalars['String'];
};

export type RunMappingResult = {
  __typename?: 'RunMappingResult';
  duration: Scalars['Float'];
  errors: Scalars['Float'];
  items: Scalars['Float'];
  results: Array<RunMappingResultLine>;
};

export type RunMappingResultLine = {
  __typename?: 'RunMappingResultLine';
  error?: Maybe<Scalars['String']>;
  mapper: RunMappingResultPathType;
  mapping: RunMappingResultPathType;
  value?: Maybe<Scalars['JSON']>;
};

export type RunMappingResultPathType = {
  __typename?: 'RunMappingResultPathType';
  key: Scalars['String'];
  path: Scalars['String'];
};

export type RuntimeLogType = {
  __typename?: 'RuntimeLogType';
  accountUuid: Scalars['String'];
  data: Scalars['JSON'];
  flowUuid?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
  time: Scalars['String'];
};

export type RuntimeLogs = {
  __typename?: 'RuntimeLogs';
  currentItems: Scalars['Float'];
  data: Array<RuntimeLogType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type RuntimeLogsForFlow = {
  __typename?: 'RuntimeLogsForFlow';
  currentItems: Scalars['Float'];
  data: Array<RuntimeLogType>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  totalItems: Scalars['Float'];
};

export type SafeString = {
  value: Scalars['String'];
};

export type SchemaValidationType = {
  __typename?: 'SchemaValidationType';
  isValid: Scalars['Boolean'];
  report?: Maybe<Array<ValidationReport>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  managementCommandLogLineAdded: ExecuteManagementCommandLogLine;
  requestLogLineAdded: ExecuteRequestLogLine;
};


export type SubscriptionManagementCommandLogLineAddedArgs = {
  args: ManagementCommandLogLineAddedInput;
};


export type SubscriptionRequestLogLineAddedArgs = {
  args: RequestLogLineAddedInput;
};

export type UpdateEntityNameDescriptionInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type UpdateEntityNameInput = {
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type UpdateEntitySchemaInput = {
  schema: Scalars['JSON'];
  uuid: Scalars['String'];
};

export type UpdateMockDataInput = {
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endpointUuid?: InputMaybe<Scalars['String']>;
  mappingUuid?: InputMaybe<Scalars['String']>;
  modelUuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  packageVersionUuid: Scalars['String'];
  source: Scalars['JSON'];
  uuid: Scalars['String'];
};

export type UpdatePackageInput = {
  companyUuid: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

export type UpdatePackageVersionStatusInput = {
  status: ContentStatus;
  uuid: Scalars['String'];
};

export type UpdatePackageVersionVariablesInput = {
  uuid: Scalars['String'];
  variables: Scalars['JSON'];
};

export type ValidateEntitySchemaInput = {
  schema: Scalars['JSON'];
};

export type ValidateToSchemaInput = {
  data: Scalars['String'];
  env?: InputMaybe<Scalars['String']>;
  schema: Scalars['String'];
};

export type ValidateToSchemaResult = {
  __typename?: 'ValidateToSchemaResult';
  errors?: Maybe<Array<ValidateToSchemaResultLine>>;
  reportingPath: Scalars['String'];
  valid: Scalars['Boolean'];
  warnings?: Maybe<Array<ValidateToSchemaResultLine>>;
};

export type ValidateToSchemaResultLine = {
  __typename?: 'ValidateToSchemaResultLine';
  handler?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  path: Scalars['String'];
};

export type ValidationReport = {
  __typename?: 'ValidationReport';
  errors: Array<Scalars['String']>;
  path: Scalars['String'];
};
